import { Sparkles } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export const PromoBanner = () => {
  const { lang } = useLang();
  const MESSAGES = lang === "en"
    ? [
        "🚚 FREE shipping over $69",
        "✨ Premium 3D raised stickers",
        "🇹🇳 Tunisian pride",
        "⭐ Quality guaranteed",
        "🎁 Today's special offer",
      ]
    : [
        "🚚 Livraison GRATUITE dès 69$",
        "✨ Adhésifs 3D premium en relief",
        "🇹🇳 Fierté tunisienne",
        "⭐ Qualité garantie",
        "🎁 Offre limitée aujourd'hui",
      ];

  const HIGHLIGHT = lang === "en" ? "FREE" : "GRATUITE";
  const PRICE_HIGHLIGHT = "69$";

  const renderMsg = (msg: string) => {
    if (msg.includes(HIGHLIGHT)) {
      const [before, after] = msg.split(HIGHLIGHT);
      return (
        <>
          {before}
          <span className="text-[hsl(40,80%,65%)] font-extrabold">{HIGHLIGHT}</span>
          {after}
        </>
      );
    }
    if (msg.includes(PRICE_HIGHLIGHT)) {
      const [before] = msg.split(PRICE_HIGHLIGHT);
      return (
        <>
          {before}
          <span className="text-[hsl(40,80%,65%)] font-extrabold">{PRICE_HIGHLIGHT}</span>
        </>
      );
    }
    return msg;
  };

  const tickerContent = (
    <>
      {MESSAGES.map((msg, i) => (
        <span key={i} className="inline-flex items-center gap-2 mx-8 whitespace-nowrap">
          <span className="text-white font-display font-bold text-sm md:text-base tracking-wide">
            {renderMsg(msg)}
          </span>
          <Sparkles className="w-3 h-3 text-[hsl(40,80%,65%)]/60" />
        </span>
      ))}
    </>
  );

  return (
    <section className="relative overflow-hidden">
      <div className="bg-gradient-to-r from-[hsl(18,78%,28%)] via-[hsl(18,78%,38%)] to-[hsl(18,78%,28%)] relative">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent bg-[length:200%_100%] animate-[shimmer_3s_ease-in-out_infinite]" />
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[hsl(40,80%,55%)] to-transparent opacity-60" />
        <div className="relative flex items-center py-1.5 px-0 overflow-hidden">
          <div className="flex-1 overflow-hidden relative">
            <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-[hsl(18,78%,28%)] to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-[hsl(18,78%,28%)] to-transparent z-10 pointer-events-none" />
            <div className="flex animate-[marquee_25s_linear_infinite]">
              {tickerContent}
              {tickerContent}
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[hsl(40,80%,55%)] to-transparent opacity-60" />
      </div>
    </section>
  );
};
